import { descifrar } from './utils/tokenUtils';

const construirClave = () => {
  const offsetToken = process.env.REACT_APP_AUTH_TOKEN;
  if (!offsetToken) return '';
  return descifrar(offsetToken);
};

export const env = {
  envName: "DEV",
  production: false,
  test: false,
  applicationName: "dossier",
  defaultLanguage: "en",
  get llaveMaestra() {
    return construirClave();
  },
  baseURL: process.env.REACT_APP_BASE_URL || "",
  cryptoKey: process.env.REACT_APP_AUTH_TOKEN || "",
};
